module.exports = __webpack_public_path__ + "static/media/guide-line-02.25a72937.svg";